import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DefaultButton from '../../components/Accessibility/DefaultButton';
import DefaultPagination from '../../components/Accessibility/DefaultPagination';
import DefaultTextBold from '../../components/Accessibility/DefaultTextBold';
import PageTitle from '../../components/Accessibility/PageTitle';
import VoltarButton from '../../components/Accessibility/VoltarButton';
import ChatCard from '../../components/ChatComEquipe/ChatCard';
import { ChatTypeEnum } from '../../components/ChatComEquipe/ChatTypeEnum';
import LoadingApp from '../../components/LoadingApp';
import ModalFeedBack from '../../components/ModalFeedBack';
import { Mensagem as Conversa } from '../../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/Mensagem';
import { getConversasPersonal } from '../../services/PlanoMaisService';
import { getConversasAbertas, getConversasConcluidas } from '../../services/SaudeBemEstar/GestaoDeCronicosService';
import { scrollTo } from '../../utils/ScrollUtil';

const ListaConversas: React.FC<{ chatType: number }> = ({ chatType }) => {

  const { statusConversa } = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);
  const [conversas, setConversas] = useState<Conversa[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageConversas, setPageConversas] = useState<Conversa[]>([]);
  const pageSize = 5;
  const navigate = useNavigate();
  const inProgressConversations = statusConversa === 'abertas';
  const chatContext = chatType === ChatTypeEnum.GC ? '/saudeBemEstar/gestaoDeCronicos' : '/saudeOnline/faleComPersonal';
  const isGc = chatType === ChatTypeEnum.GC;
  const subtitleText = inProgressConversations ? 'Conversas em andamento' : 'Histórico de conversas concluídas';

  const fetchConversasGC = async () => {
    setLoading(true);
    const getConversas = inProgressConversations ? getConversasAbertas : getConversasConcluidas;
    const response = await getConversas();
    if (response?.status === 200) {
      const conversas = response.data;
      setConversas(conversas);
      setPageConversas(conversas.slice(0, pageSize));
    } else {
      console.error(response);
      handleFetchConversationsError();
    }
    setLoading(false);
  }

  const fetchConversasPersonal = async () => {
    setLoading(true);
    const response = await getConversasPersonal();
    if (response?.status === 200) {
      const conversas: Conversa[] = response.data;
      const conversasAbertas: Conversa[] = [];
      const conversasConcluidas: Conversa[] = [];
      conversas.forEach(conversa => {
        if (conversa.status === 'MP') {
          conversasAbertas.push(conversa);
        } else if (conversa.status === 'MF') {
          conversasConcluidas.push(conversa);
        }
      });
      const conversasFiltered = inProgressConversations ? conversasAbertas : conversasConcluidas;
      setConversas(conversasFiltered);
      setPageConversas(conversasFiltered.slice(0, pageSize));
    } else {
      console.error(response);
      handleFetchConversationsError();
    }
    setLoading(false);
  }

  const handleFetchConversationsError = () => {
    openModal('error', 'Erro', 'Ocorreu um erro ao buscar as conversas. Tente novamente mais tarde.',
      'Fechar', () => window.history.back(), () => window.history.back());
  }

  useEffect(() => {
    if (isGc) fetchConversasGC(); else fetchConversasPersonal();
  }, []);

  const openModal = (
    icon: 'success' | 'warning' | 'error', title: string, subTitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon,
      title,
      subTitle,
      textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  const handlePageChange = async (page: number) => {
    setPage(page)
    const start = (page - 1) * pageSize
    const nextPageData = conversas.slice(start, start + pageSize);
    scrollTo('scroll-ref');
    setPageConversas(nextPageData);
  }

  return (
    <>
      <LoadingApp showLoading={loading} text='Carregando...' />
      <div className='chat-infos-container'>
        <PageTitle text={isGc ? 'Chat com equipe' : 'Fale com o personal'} />

        <DefaultTextBold text={subtitleText} large id='scroll-ref' />

        {inProgressConversations &&
          <div className='chat-buttons-container'>

            <DefaultButton text='Iniciar nova conversa' onClick={() => navigate(`${chatContext}/conversaEquipe/conversas/nova`)} />
          </div>
        }

        {conversas.length > 0 &&
          <>
            {pageConversas.map((conversa, index) => (
              <ChatCard key={index} conversa={conversa} chatType={chatType} />
            )
            )}
          </>
        }
        <DefaultPagination
          currentPage={page}
          totalPages={Math.ceil(conversas.length / pageSize)}
          handlePageChange={handlePageChange}
        />
        <VoltarButton text='Voltar' onClick={() => window.history.back()} />
      </div >
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default ListaConversas;